// extracted by mini-css-extract-plugin
export default {"container":"CookiesScreen_container__UDRWU","content":"CookiesScreen_content__4YsrX"};